import { useCallback, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { Box } from "theme-ui";

import { HomePages } from "./home.types";
import { HomeLayout } from "./home-layout";
import { Login } from "./login/login";
import { Signup } from "./signup/signup";

export const Home = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { linkExpired } = location.state || {};
  const [page, setPage] = useState<HomePages>(linkExpired ? HomePages.signup : HomePages.login);
  const goToSignup = useCallback(() => {
    setPage(HomePages.signup);
  }, []);

  const goToLogin = useCallback(() => {
    setPage(HomePages.login);

    if (linkExpired) {
      navigate("/"); // reset the link expired state and enable login/signup screen toggles
    }
  }, [linkExpired, navigate]);

  return (
    <HomeLayout page={page}>
      <Box
        aria-label="home-wrapper"
        sx={{
          width: "100%",
          mt: page === HomePages.signup ? -500 : 0,
          transition: "margin 0.3s ease-in-out",
        }}
      >
        {page === HomePages.login && <Login goToSignup={goToSignup} page={page} />}
        {page === HomePages.signup && (
          <Box
            sx={{
              mt: 500,
            }}
          >
            <Signup goToLogin={goToLogin} page={page} linkExpired={linkExpired} />
          </Box>
        )}
      </Box>
    </HomeLayout>
  );
};
